<!-- 销售订单数据操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                    <el-row v-if="dataActionBox.actionType != 2">

                      <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField"
                        :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                        <!-- 日期 -->
                        <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)" :isShowLong="false" :isdisabled="formOneValue.isChange == 0
                                                        || dataActionBox.actionType == 2
                                                        || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)">
                        </df-date>
                        <!-- 检索方案 -->
                        <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                          :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
                          :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                          <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" :disabled="formOneValue.isChange == 0
                                                        || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)
                                                        || dataActionBox.actionType == 2">
                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append" icon="el-icon-search"
                              :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0) || dataActionBox.actionType == 2">
                            </el-button>
                          </el-input>
                        </el-tooltip>
                        <!-- formatter下拉选   :automatic-dropdown="true"-->
                        <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange" :disabled="formOneValue.isChange == 0
                                                        || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)
                                                        || dataActionBox.actionType == 2" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                          </el-option>
                        </el-select>
                        <!-- 账期 -->
                        <el-input @keyup.enter.native="nextFocus(formOneKey)" type="number" v-else-if="formOneValue.entityField == 'credit'"
                          :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                        <!-- string类型 -->
                        <el-input @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)" v-else :disabled="formOneValue.isChange == 0
                                                        || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)
                                                        || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType == 2">
                      <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                        <span v-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                        </span>
                        <span v-else-if="formOneValue.fieldType == 'date'">
                          <span v-if="sendDataInfo[formOneValue.entityField]">
                            {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                          </span>
                        </span>
                        <span v-else-if="formOneValue.entityField == 'isWms'">{{ sendDataInfo.isWms== 1 ? '是' : '否' }}</span>
                        <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                  <!-- 明细操作 -->
                  <el-form :inline="true" size="mini">
                    <el-dropdown style="margin-left: 5px;" v-if="$store.state.btnlist" trigger="click">
                      <el-button type="primary">
                        辅助功能<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <template #dropdown>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-for="(item, index) in JSON.parse($store.state.btnlist)" :key="index" @click.native="Historical(item.mdSource, item.mdName)">{{
                            item.mdName
                          }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                    <!-- 明细信息 -->
                    <el-table class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.woApplyDetails" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange" border
                      size="mini" :height="mxHeight">
                      <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                        <template slot-scope="scope">
                          <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                          </el-radio>
                        </template>
                      </el-table-column>
                      <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in mxForm.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1"
                        :min-width="formOneValue.fieldWeight" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <!-- 显示通用名称 -->
                          <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName'
                                                        && dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable
                            @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField, formOneValue.setField)"
                            v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                            <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField, formOneValue.setField)" slot="append" icon="el-icon-search">
                            </el-button>
                          </el-input>
                          <span v-else-if="formOneValue.isRift == 1">
                            <a @click="toDetail(sendDataInfo.woApplyDetails[scope.$index][formOneValue.riftField])">
                              {{
                                                                sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]
                                                            }}</a>
                          </span>
                          <!-- 生产日期 -->
                          <span v-else-if="formOneValue.fieldType == 'date'">
                            <span v-if="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                              {{
                                                                $common.getLocalTime(sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField])
                                                            }}
                            </span>
                          </span>
                          <!-- 含税价格 -->
                          <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'psprice'
                                                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="sendDataInfo.woApplyDetails[scope.$index].useNum <= 0" @change="doCheckPrice(2, scope.$index)"
                            @input="calculatePrice(2, scope.$index)" v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                          </el-input>
                          <!-- 单价 -->
                          <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'price'
                                                            && dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number" :disabled="sendDataInfo.woApplyDetails[scope.$index].useNum <= 0"
                            @input="calculatePrice(1, scope.$index)" v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                          </el-input>
                          <span v-else>
                            {{
                                                            sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]
                                                        }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>

        <div class="foot">
          <div>
            <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
            </el-button>
            <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo',)" v-if="dataActionBox.actionType == 0">保存</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">确定提交</el-button>
          </div>
          <div v-if="footForm">
            <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
              <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                <el-button type="success">{{ itemV.entityField == 'totalMoney' ?
                                    $common.getDecimalInfo(3, sendDataInfo[itemV.entityField])
                                    : sendDataInfo[itemV.entityField] }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <printPlan ref="printPlan"></printPlan>
    <component :is="currentComponent" :ref="currentComponent"></component>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";

export default {
  name: "querMoneysettlementAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
  },
  data() {
    //这里存放数据
    return {
      //--------------------
      dialogList: [],
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      currentComponent: "",
      historicalOrder: {
        cmName: "",
        cmId: "",
        bgmName: "",
        bgmId: "",
      },
      sendDataInfo: {
        woApplyDetails: [], // 明细列表，必须初始化
      },
      inputel: "", //所有input对象
      detaislDataInfo: {},
      showTabs: "",
      formDataList: [],
      dictionariesData: {},
      // userOneList:[],
      selectedDetailsIndex: 0,
      editDateilsIndex: "",
      giftsList: [],
      seTitle: "", //检索
      DialogVisible: false,
      seId: 0,
      cmId: "",
      ormId: "",
      coId: 0,
      seType: "",
      setField: "",
      seIndex: 0,
      levleId: 0,
      seWidth: "0",
      mxHeight: 0,
      isLoaded: false,
      pageType: "one",
      parentSearchData: {
        orderType: 0, //	订单类型0.药品1.器械
      },
      selectedRow: [], // 当前已选择行
      mainFormList: [], //过滤的主表单
      tabForm: [], // tab循环的主表单
      mxForm: [],
      footForm: [],
      sField: "", // 赋值字段
      fField: "", //焦点字段
      nosField: "", // 不可赋值字段
      DialogExtract: false, //提取
      exId: "",
      exTitle: "",
      exWidth: "",
      ppId: "orderId",
      ticket: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "sendDataInfo.woApplyDetails": {
      handler: function (newValue, oldValue) {
        this.sendDataInfo.totalCount = 0; //总条目数
        this.sendDataInfo.totalMoney = 0; // 总金额
        this.sendDataInfo.totalNumber = 0; // 总数量
        newValue.forEach((item, keys) => {
          for (let key in item) {
            if (item[key] == null || item[key] == "null") {
              this.sendDataInfo.woApplyDetails[keys][key] = "";
            }
          }
          let a = String(item.useNum);
          if (item.useNum == "" || item.useNum == 0) {
            item.useNum = 0;
          } else if (
            a.length > 1 &&
            a.substring(0, 1) == "0" &&
            a.substring(1, 2) != "."
          ) {
            item.useNum = a.substring(1, a.length);
          }
          let b = item.psprice;
          if (item.psprice == "") {
            item.psprice = 0;
          } else if (
            b.length > 1 &&
            b.substring(0, 1) == "0" &&
            b.substring(1, 2) != "."
          ) {
            item.psprice = b.substring(1, b.length);
          }

          // 计算销售单价
          var thisPrice = this.$common.getDecimalInfo(
            2,
            NP.minus(
              item.psprice,
              NP.divide(NP.times(item.psprice, item.outRate), 100)
            )
          );
          item.price = this.$common.getDecimalInfo(
            2,
            parseFloat(item.price)
          );

          this.sendDataInfo.totalMoney = NP.plus(
            parseFloat(this.sendDataInfo.totalMoney),
            parseFloat(item.psmoney)
          );
          this.sendDataInfo.totalNumber = NP.plus(
            parseFloat(this.sendDataInfo.totalNumber),
            parseFloat(item.useNum)
          );
        });
        this.sendDataInfo.totalCount = newValue.length;
      },
      deep: true,
    },
    "sendDataInfo.dismode": {
      handler: function (newstr, oldValue) {
        this.$nextTick(() => {
          let newValue = newstr ? newstr.replace(/\s*/g, "") : ''
          this.sendDataInfo.dismode = newValue
          if (newValue == "自提" || newValue == "配送") {
            this.tabForm[0].jurconfigform.forEach((item) => {
              if (item.entityField == "companyName") {
                item.isShow = 0;
              }
            });
          } else {
            this.tabForm[0].jurconfigform.forEach((item) => {
              if (item.entityField == "companyName") {
                item.isShow = 1;
              }
            });
          }
        })

        this.$forceUpdate();
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    tabHeight(val) {
      this.mxHeight = val
    },
    Historical(url, title) {
      this.currentComponent = url;
      if (this.currentComponent == "historicalSalesOrder") {
        this.historicalOrder.cmName = this.sendDataInfo["cmName"];
        this.historicalOrder.cmId = this.sendDataInfo["cmId"];
      }
      if (this.sendDataInfo["woApplyDetails"] && Array.isArray(this.sendDataInfo["woApplyDetails"]) && this.sendDataInfo["woApplyDetails"].length > 0) {
        this.historicalOrder.bgmId =
          this.sendDataInfo["woApplyDetails"][
            this.selectedDetailsIndex
          ].bgmId;
        this.historicalOrder.bgmName =
          this.sendDataInfo["woApplyDetails"][
            this.selectedDetailsIndex
          ].bgmName;
      }
      this.$nextTick(() => {
        this.$refs[this.currentComponent].openBox(
          this.historicalOrder,
          title
        );
      });
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById("mainInfo");
      if (el) this.inputel = el.getElementsByTagName("input");
    },
    // 主表单select框切换enter切换焦点事件方法
    selectChange(e) {
      if (e == false) {
        for (let index = 0; index < this.inputel.length; index++) {
          if (this.inputel[index] == document.activeElement) {
            this.nextFocus(index);
            break;
          }
        }
      }
    },

    // 输入框切换焦点
    nextFocus(index, fField) {
      if (index >= this.inputel.length - 1) {
        if (this.sendDataInfo.woApplyDetails.length > 0) {
        }
        this.addDetail("sendDataInfo");
        return;
      }
      if (fField == "keydown") {
        return;
      }
      var aindex = index + 1;
      if (
        this.inputel[aindex].value != "" ||
        this.inputel[aindex].disabled
      ) {
        this.nextFocus(aindex);
        return;
      }
      this.$nextTick(() => {
        this.inputel[aindex].focus();
      });
    },

    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == "") {
          this.inputel[index].focus();
          break;
        }
      }
    },
    closeChild() {
      this.parentSearchData.bgmId = "";
      this.parentSearchData.bgmName = "";
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    // 表格切换焦点方法
    tableNextFocus(field, index) {
      this.seIndex = index;
      if (field == "keydown") {
        if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
          this.$refs["bgmName"][index + 1].focus();
          this.selectedDetailsIndex = index + 1;
          this.$nextTick(() => {
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
            );
          });
          return;
        }
        return;
      }
      this.$refs[field][index].focus();
    },

    // 监听键盘事件
    keyUp(e) {
      if (e.keyCode == 40) {
        // 下键
        // 表格为空，不执行下方
        if (this.sendDataInfo.woApplyDetails.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 如果当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (
            this.selectedDetailsIndex ==
            this.sendDataInfo.woApplyDetails.length - 1
          ) {
            // 如果选中的是最后一行了，那么下一行选中的是第一行
            this.selectedDetailsIndex = 0;
          } else {
            // 正常递增
            this.selectedDetailsIndex++;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.woApplyDetails[
              this.selectedDetailsIndex
              ],
              false
            );
            return;
          }
          // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      } else if (e.keyCode == 38) {
        // 上键
        if (this.sendDataInfo.woApplyDetails.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (this.selectedDetailsIndex == 0) {
            // 如果选中的是第一行了，那么下一行选中的是最后一行
            this.selectedDetailsIndex =
              this.sendDataInfo.woApplyDetails.length - 1;
          } else {
            // 正常递减
            this.selectedDetailsIndex--;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.woApplyDetails[
              this.selectedDetailsIndex
              ],
              false
            );
            return;
          }
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      }
    },

    // 表格方法
    rowClassName({ row, rowIndex }) {
      let rowName = "",
        findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },

    // 选中行底色逻辑
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, "rowIndex", {
        // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false,
      });
      let rowBackground = {};
      if (row.bgColor && row.bgColor != "")
        rowBackground.backgroundColor = row.bgColor;
      return rowBackground;
    },

    // 明细表格点击选中
    clickEvent(row, column, event, params) {
      let refsElTable = this.$refs.mxTableRef; // 获取表格对象
      let findRow = {};
      this.selectedDetailsIndex = row.rowIndex;
      findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.selectedRow.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
    },

    // 保存已选择行
    handleSelectionChange(rows) {
      this.selectedRow = rows; // 保存已选择行
    },

    // 子组件穿透方法
    toDetail(orderId) {
      if (this.dataActionBox.actionType != 2)
        this.$parent.$parent.toDetail(orderId);
      else this.$parent.$parent.$parent.toDetail(orderId);
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
    openSearch(sId, index, type, sField, fField, nosField, setField) {
      this.DialogVisible = true;
      removeEventListener("keyup", this.keyUp);
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField;
      this.fField = fField;
      this.nosField = nosField;
      this.parentSearchData[type] = this.sendDataInfo[type];

    },

    // 不可赋值字段
    noSetField(val) {
      let arr = this.nosField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = "";
      });
    },

    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = val[item];
      });
      this.$nextTick(() => {
        this.nextFocus(this.seIndex, this.fField);
      });
    },

    // 清除赋值字段数据
    clearValue() {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = "";
      });
    },

    //检索带回数据,
    changeInputModel(val) {
      console.log(val, this.seType);
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.$nextTick(() => {
          addEventListener("keyup", this.keyUp); //创建监听键盘事件
          this.paramValue(val);
        });
      }
    },

    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    // 打印方法
    showPrintPlan() {
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(
          this.actionData.orderId,
          this.actionData.printSouce,
          this.actionData.printJurId
        );
      } else {
        return;
      }
    },
    //确认新增
    async sendDataAction(formName1) {
      let flag = false;
      // this.$refs[formName1].validate((valid) => {
      //     if (valid) {
      //     } else {
      //         this.$message({
      //             message: "请完善主表单必填信息",
      //             type: "error",
      //         });
      //         flag = true;
      //         return false;
      //     }
      // });
      const params = {
        detailList: this.sendDataInfo.woApplyDetails,
        woamId: this.sendDataInfo.woamId,
        wmId: this.sendDataInfo.wmId,
        totalMoney: this.sendDataInfo.totalMoney,
        totalNumber: this.sendDataInfo.totalNumber,
        totalCount: this.sendDataInfo.totalCount,
        woamSaledate: this.sendDataInfo.woamSaledate,
      }
      var responseData = await this.$http.highvalueaccountingExpenses(params);

      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel");
      } else {
        this.$message.error(responseData.message)
      }
    },
    //含税价拦截
    doCheckPrice(cate, index) {
      var info = this.sendDataInfo.woApplyDetails[index];

      // console.log('info',info);
      let pspriceObj = {
        coId: this.sendDataInfo.coId, //货主ID
        bgmId: info.bgmId, //商品ID
        psprice: info.psprice, //商品价格
        costPrice: info.woadWcost, //成本价
        cmId: this.sendDataInfo.cmId, //客户ID
        bgsId: info.bgsId, //库存ID
        lowestPrice: info.lowestPrice, //最低售价
      };
      this.$http.checkPrice(pspriceObj).then((res) => {
        console.log("psprice", res);
        if (res.status == 200) {
          this.calculatePrice(cate, index);
        } else if (res.status == 300) {
          this.$refs["psprice"][index].focus();
          this.$message({
            message: res.message,
            type: "warning",
          });
          this.sendDataInfo.woApplyDetails[index].psprice = info.psprice;
        } else {
          this.$refs["psprice"][index].focus();
          this.$message({
            message: res.message,
            type: "error",
          });
          this.sendDataInfo.woApplyDetails[index].psprice = 0;
          this.calculatePrice(cate, index);
          this.selectedDetailsIndex = index + 1
          this.deleteDetails()
        }
      });
    },
    // 计算价格
    calculatePrice(cate = 1, index) {
      var info = this.sendDataInfo.woApplyDetails[index];
      console.log(info.psprice);
      if (this.sendDataInfo.orderId == "") {
        if (info.useNum <= 0) {
          this.$message({
            message: "请先填写合理的使用数量",
            type: "error",
          });
          this.$set(info, "useNum", 0);
          this.$set(info, "money", 0);
          this.$set(info, "psmoney", 0);
          this.$set(info, "gross", 0); //毛利
          this.$set(info, "costMoney", 0); //含税成本金额
          this.$set(info, "costAmount", 0); //成本金额
          return false;
        } else if (info.useNum > info.saleableNum) {
          info.useNum = info.saleableNum;
          this.$message({
            message: "使用数量不能大于销售数量",
            type: "error",
          });
        }
      }
      switch (cate) {
        case 1: // 通过单价计算全部
          // 计算含税价格 单价+单价*税率/100
          var thisPrice = this.$common.getDecimalInfo(
            2,
            NP.plus(
              info.price,
              NP.divide(NP.times(info.price, info.outRate), 100)
            )
          );

          // 计算金额 单价*数量
          this.sendDataInfo.woApplyDetails[index].money =
            this.$common.getDecimalInfo(
              3,
              NP.times(info.price, info.useNum)
            );

          // 计算含税金额 含税价格*数量
          this.sendDataInfo.woApplyDetails[index].psmoney =
            this.$common.getDecimalInfo(
              3,
              NP.times(thisPrice, info.useNum)
            );
          //计算税额
          this.sendDataInfo.woApplyDetails[index].taxAmount =
            this.$common.getDecimalInfo(
              3,
              NP.minus(info.psmoney, info.money)
            );
          this.sendDataInfo.woApplyDetails[index].taxAmount = this.sendDataInfo.woApplyDetails[index].taxAmount == 0 ? 0 : this.sendDataInfo.woApplyDetails[index].taxAmount
          break;
        case 2: // 通过含税价格计算全部
          // this.getGoodsSockPrice(index)	//检测最低价/特价申请
          console.log(this.sendDataInfo.woApplyDetails[index].taxAmount);
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.woApplyDetails[index].psmoney = info.useNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.useNum));
          // 计算金额 含税金额/(税率/100+1)
          // var midmoney = NP.divide(this.sendDataInfo.woApplyDetails[index].psmoney, NP.plus(NP.divide(info.outRate, 100), 1)).toFixed(10)
          var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.woApplyDetails[index].psmoney, NP.plus(NP.divide(info.outRate, 100), 1)));
          this.sendDataInfo.woApplyDetails[index].money = this.$common.getDecimalInfo(3, midmoney);
          // 计算单价 金额/数量
          this.sendDataInfo.woApplyDetails[index].price = info.useNum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.useNum));
          //计算税额
          this.sendDataInfo.woApplyDetails[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.woApplyDetails[index].psmoney, this.sendDataInfo.woApplyDetails[index].money));
          this.sendDataInfo.woApplyDetails[index].taxAmount = this.sendDataInfo.woApplyDetails[index].taxAmount == 0 ? 0 : this.sendDataInfo.woApplyDetails[index].taxAmount
          break;
      }
      // 含税金额
      var moneyFour = this.sendDataInfo.woApplyDetails[index].psmoney;
      // 含税成本金额
      var moneyFive = this.sendDataInfo.woApplyDetails[index].costMoney;

      // 毛利 = 含税金额 - 成本含税金额
      this.sendDataInfo.woApplyDetails[index].gross =
        this.$common.getDecimalInfo(3, NP.minus(moneyFour, moneyFive));

      // 不含税毛利 = 金额 - 成本金额
      this.sendDataInfo.woApplyDetails[index].taxgross =
        this.$common.getDecimalInfo(
          3,
          NP.minus(info.money, info.costAmount)
        );
      //毛利率
      this.sendDataInfo.woApplyDetails[index].grossProfit = moneyFour != 0 ?
        this.$common.toFixed2(
          NP.divide(
            this.sendDataInfo.woApplyDetails[index].gross,
            moneyFour
          ),
          2
        ) : 0
      this.sendDataInfo.woApplyDetails.splice(1, 0);
      //页脚
      this.sendDataInfo.totalMoney = moneyFour;
      this.sendDataInfo.totalNumber = info.useNum;
      this.sendDataInfo.totalCount = this.sendDataInfo.woApplyDetails.length;
    },
    //计算数量
    calculate(index) {
      var info = this.sendDataInfo.woApplyDetails[index];
      // 计算整件数量
      this.sendDataInfo.woApplyDetails[index].wholeNum = Math.floor(NP.divide(info.useNum, Number(info.packingSpec)));
      //计算零散数量
      this.sendDataInfo.woApplyDetails[index].scatNum = NP.minus(info.useNum, NP.times(this.sendDataInfo.woApplyDetails[index].wholeNum, Number(info.packingSpec)));
      // 计算件数 采数/包装单位
      if (parseFloat(info.packingSpec) <= 0 || info.packingSpec == "") {
        this.sendDataInfo.woApplyDetails[index].pieceNum = 0;
      } else {
        this.sendDataInfo.woApplyDetails[index].pieceNum =
          this.$common.getDecimalInfo(
            1,
            NP.divide(info.useNum, info.packingSpec)
          );
      }
    },

    //取消
    initActionBox(formName1, formName2) {
      this.$confirm(
        "确定取消" + this.dataActionBox.boxTitle + "吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$emit("drawerCancel");
          this.init();
          this.$refs[formName1].resetFields();
          this.$refs[formName2].resetFields();
        })
        .catch(() => { });
    },

    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "woApplyDetails") {
          this.sendDataInfo[key] = [];
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      this.sendDataInfo.woamSaledate = this.$moment().valueOf();

      this.sendDataInfo.woApplyDetails = [];
      this.sendDataInfo.totalCount = 0;
      this.sendDataInfo.totalMoney = 0;
      this.sendDataInfo.totalNumber = 0;
      this.sendDataInfo.orderType = 0; //orderType	订单类型0.药品订单1.器械订单
    },
    //上级流入
    async openBox() {
      console.log(this.actionData, 'actionData完整内容');
      
      // 安全检查：确保 formData 存在
      if (!this.actionData || !this.actionData.formData || !this.actionData.formData.length) {
        console.error('actionData.formData 数据缺失，无法渲染页面');
        return;
      }
      
      this.pageType = this.actionData.type;
      this.dataActionBox.actionType = this.actionData.cate;
      this.formDataList = this.actionData.formData;
      this.showTabs = this.actionData.formData[0].jciName;

      var oldData = this.actionData.oldData;

      oldData = await this.queryMoneyAccountingDetail(this.actionData.orderId) || {}
      console.log(oldData, '接口返回的oldData');
      
      // 检查接口返回数据
      if (!oldData || !oldData.detailList) {
        console.error('接口返回数据异常，detailList缺失');
      }
      
      this.filterMainField();
      this.init();
      
      // 统一设置 woApplyDetails（模板使用的是 woApplyDetails，接口返回的是 detailList）
      const detailList = oldData.detailList || [];
      this.$set(this.sendDataInfo, 'woApplyDetails', detailList);
      
      // 将 lastSelesPrice 自动赋值给 psprice，并触发计算逻辑
      this.sendDataInfo.woApplyDetails.forEach((item, index) => {
        if (item.lastSelesPrice !== undefined && item.lastSelesPrice !== null && item.lastSelesPrice !== '') {
          this.$set(this.sendDataInfo.woApplyDetails[index], 'psprice', item.lastSelesPrice);
          this.calculatePrice(2, index);
        }
      });
      
      
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
        for (let key in oldData) {
          if (key !== 'detailList') {
            this.$set(this.sendDataInfo, key, oldData[key])
          }
        }
      } else if (this.dataActionBox.actionType == 1) {
        this.cmId = oldData.cmId;
        this.ormId = oldData.ormId
          ? oldData.ormId
          : JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
        this.coId = oldData.coId;
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        for (const key in oldData) {
          if (key !== 'detailList') {
            this.$set(this.sendDataInfo, key, oldData[key])
          }
        }
        this.sendDataInfo.woApplyDetails.forEach((item, index) => {
          this.calculate(index)
        })
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        for (let key in oldData) {
          if (key !== 'detailList') {
            this.$set(this.sendDataInfo, key, oldData[key])
          }
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.$refs['tree'].init(this.sendDataInfo.wmId)
            this.mxHeight = this.$common.getHeight()
          }
          this.initFocus();
        }, 16.7)
      });
      // 所有数据准备完成后，设置 isLoaded = true
      this.isLoaded = true;
    },
    //查询费用核算详情
    async queryMoneyAccountingDetail(orderId) {
      let params = {
        ids: [orderId],
      }
      // console.log(orderId,'orderId2222222222')
      var responseData = await this.$http.queryMoneyAccountingDetail(params);
      if (responseData.status == 200) {
        return responseData.result
        // this.sendDataInfo = responseData.data
      }else{
        this.$message.error(responseData.msg)
      }
      
    },
    // 默认值
    initDefaultValue() {
      let arr = this.formDataList[0].jurconfigform;
      arr.forEach((item) => {
        if (
          item.defaultValue != "null" &&
          item.defaultValue != null &&
          item.defaultValue != ""
        ) {
          this.sendDataInfo[item.entityField] = item.defaultValue;
        }
      });
      this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms);
      this.sendDataInfo.woamSaledate = this.$moment().valueOf();
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = [];
      this.formDataList.forEach((item) => {
        if (item.jciType == 1) {
          mainFormList.push(item);
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item));
          this.mxForm.jurconfigform.forEach(item1 => {
            if (item1.fieldType == 'number') {
              this.$set(this.detaislDataInfo, item1.entityField, 0)
            } else if (item1.fieldType == 'search' && item1.setField) {
              var arr = item1.setField.split(',')
              arr.forEach(item2 => {
                this.$set(this.detaislDataInfo, item2, "")
              })
            } else {
              this.$set(this.detaislDataInfo, item1.entityField, "")
            }
          })
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
        }
      });
      // 使用临时数组，最后整体赋值触发Vue响应式更新
      const tempTabForm = [];
      mainFormList.forEach((key, i) => {
        const tabItem = JSON.parse(JSON.stringify(key));
        tabItem.jurconfigform = [];
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1)
            tabItem.jurconfigform.push(key.jurconfigform[index]);
        }
        tempTabForm.push(tabItem);
      });
      // 整体赋值触发响应式更新
      this.tabForm = tempTabForm;
      var arr = [{ entityField: "woApplyDetails" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {
        this.$set(this.sendDataInfo, key, obj[key])
      }
      this.$set(this.sendDataInfo, "orderType", 1)
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.openBox();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // addEventListener('keydown', this.keyDown)
    addEventListener("keyup", this.keyUp); //创建监听键盘事件
  },
  beforeDestroy() {
    removeEventListener("keyup", this.keyUp);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput();
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}
</style>
<style>
.el-table .rowStyle {
  background: #fff7ca !important;
}
</style>